export default __webpack_public_path__ + "static/media/miguel-lopes-27.6221e15e.jpg";